export const PMM_SETTINGS_URL = '/graph/settings/advanced-settings';
export const PMM_DATABASE_CHECKS_PANEL_URL = '/graph/advisors/insights';
